module.exports = __webpack_public_path__ + "img/icStar.2f35306f.svg";